import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {

    return (
       <footer className="section SiteFooterSection theme--light accent--Slate Section--paddingNormal Section--hasGuides Section--hasStickyNav">
           <div className="section_masked">
                <div className="section_backgroundMask">
                    <div className="section_background">
                        <div className="guides hero-guides">
                            <div className="guidesContainer">
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sectionContainer">
                    <div className="sectionLayoutContainer">
                        <div className="sectionLayout">
                            <div className="SiteFooterSection_layout">
                                <div className="SiteFooterSection_column--copyright SiteFooterSection_column">
                                    <div className="SiteFooterSection_logoContainer">
                                        <div className="SiteFooterSection_logo">
                                            <Link className="SiteFooterSection_logoLink" to="/"><img src="/img/logo.png" alt="Riverland Technology Services Logo" className="SiteFooterSection_logo-logo" /></Link>
                                        </div>
                                    </div>
                                    <section className="List SiteFooterSection_copyright">
                                        <ul className="List_list">
                                            <li className="List_item ListItem">
                                                <span className="ListItem_label">
                                                    © 2022 Riverland Technology Services
                                                </span>
                                            </li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="SiteFooterSection_column">
                                    <section className="List List--hasTitle">
                                        <h1 className="CopyTitle CopyTitle--variant CopyTitle--inline List_title">Products</h1>
                                        <ul className="List_list">
                                            <li className="List_item ListItem">
                                                <Link to="/products/phone-system" className="link ListItem_label">3CX Management</Link>
                                            </li>
                                            <li className="List_item ListItem">
                                                <Link to="/products/web-development" className="link ListItem_label">Web Development</Link>
                                            </li>
                                            <li className="List_item ListItem">
                                                <Link to="/products/web-hosting" className="link ListItem_label">Web Hosting</Link>
                                            </li>
                                            <li className="List_item ListItem">
                                                <Link to="/products/computers" className="link ListItem_label">Computers and Laptops</Link>
                                            </li>
                                            <li className="List_item ListItem">
                                                <Link to="/products/it-infrastructure" className="link ListItem_label">IT Infrastructure</Link>
                                            </li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="SiteFooterSection_column">
                                    <section className="List List--hasTitle">
                                        <h1 className="CopyTitle CopyTitle--variant CopyTitle--inline List_title">About Us</h1>
                                        <ul className="List_list">
                                            <li className="List_item ListItem">
                                                <Link to="/about" className="link ListItem_label">About Riverland Technology Services</Link>
                                            </li>
                                            <li className="List_item ListItem">
                                                <Link to="/team" className="link ListItem_label">Our Team</Link>
                                            </li>
                                            <li className="List_item ListItem">
                                                <a href="https://support.riverlandtech.au" className="link ListItem_label">Support</a>
                                            </li>
                                        </ul>
                                    </section>
                                </div>
                                <div className="SiteFooterSection_column">
                                    <section className="List List--hasTitle">
                                        <h1 className="CopyTitle CopyTitle--variant CopyTitle--inline List_title">Resources</h1>
                                        <ul className="List_list">
                                            <li className="List_item ListItem">
                                                <Link to="/about#enquire" className="link ListItem_label">Contact</Link>
                                            </li>
                                            <li className="List_item ListItem">
                                                <Link to="/blog" className="link ListItem_label">Blog</Link>
                                            </li>
                                            <li className="List_item ListItem">
                                                <Link to="/privacy" className="link ListItem_label">Privacy Policy</Link>
                                            </li>
                                            <li className="List_item ListItem">
                                                <Link to="/returns" className="link ListItem_label">Return Policy</Link>
                                            </li>
                                            <li className="List_item ListItem">
                                                <a href="https://newsletter.riverlandtech.au" className="link ListItem_label">Newsletter</a>
                                            </li>
                                        </ul>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           </div>
       </footer> 
    );
}

export default Footer